module.exports = __webpack_public_path__ + "static/media/smallDown.a193ca76.svg";